import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import { Utils } from './../../utils/Utils.js';
import $ from 'jquery'; 
import { ReactComponent as WorldMapIcon } from '../../icons/svg/world-map.svg';
import CountUp from 'countup/dist/countUp.js';

export default class MapStatsPanel extends NrgComponent {

  constructor(props) {
    super(props);

    this.countersAnimated = false;

    this.conversationsPerDay = 293635
    this.interviewsPerDay = 3066

    // Interviews
    this.numberOfInterviews = this.totalInterviews()
    this.interviewsStartValue = this.numberOfInterviews - 1000000

    // Conversations
    this.numberOfConversations = this.totalConversationsThisYear()
    this.conversationsStartValue = this.numberOfConversations - 1000000
  }

  componentDidMount() {
    const decimals = 0
    const duration = 1.5
    const options = {
      separator: '.'
    }

    const interviewsAnimation = new CountUp(
      'interviewsNumber',
      this.interviewsStartValue,
      this.numberOfInterviews,
      decimals,
      duration,
      options
    )

    const conversationsAnimation = new CountUp(
      'conversationsNumber',
      this.conversationsStartValue,
      this.numberOfConversations,
      decimals,
      duration,
      options
    )

    // Do the animations, then activate "real time" mode
    interviewsAnimation.start(() => {
      const interviewsPerSecond = this.interviewsPerDay / 24 / 60 / 60
      const incrementInterval = 1000 / interviewsPerSecond;
      var i = 0;

      // Infinite manual increments
      setInterval(
        () => {
          const startVal = this.numberOfInterviews + i;
          const endVal = startVal + 1;

          $('#interviewsNumber').html(
            Utils.addCommasToNumber(endVal)
          )

          i++
        },
        incrementInterval
      )
    });

    conversationsAnimation.start(() => {
      const conversationsPerSecond = this.conversationsPerDay / 24 / 60 / 60
      const incrementInterval = 1000 / conversationsPerSecond;
      var i = 0;

      // Infinite manual increments
      setInterval(
        () => {
          const startVal = this.numberOfConversations + i;
          const endVal = startVal + 1;

          $('#conversationsNumber').html(
            Utils.addCommasToNumber(endVal)
          )

          i++
        },
        incrementInterval
      )
    });

    // Replace waypoints with another library, not the jquery one.
    // const animationTrigger = new Waypoint(
    //   {
    //     element: this.refs.panel,
    //     offset: $(window).height() * 0.7,
    //     handler: (direction) => {
    //       // Activate our two CountUp animations
    //       if (this.countersAnimated === false && direction === 'down') {
    //         this.countersAnimated = true;

    //         // Do the animations, then activate "real time" mode
    //         // interviewsAnimation.start(() => {
    //         //   const interviewsPerSecond = this.interviewsPerDay / 24 / 60 / 60
    //         //   const incrementInterval = 1000 / interviewsPerSecond;
    //         //   var i = 0;

    //         //   // Infinite manual increments
    //         //   setInterval(
    //         //     () => {
    //         //       const startVal = this.numberOfInterviews + i;
    //         //       const endVal = startVal + 1;

    //         //       $('#interviewsNumber').html(
    //         //         Utils.addCommasToNumber(endVal)
    //         //       )

    //         //       i++
    //         //     },
    //         //     incrementInterval
    //         //   )
    //         // });

    //         // conversationsAnimation.start(() => {
    //         //   const conversationsPerSecond = this.conversationsPerDay / 24 / 60 / 60
    //         //   const incrementInterval = 1000 / conversationsPerSecond;
    //         //   var i = 0;

    //         //   // Infinite manual increments
    //         //   setInterval(
    //         //     () => {
    //         //       const startVal = this.numberOfConversations + i;
    //         //       const endVal = startVal + 1;

    //         //       $('#conversationsNumber').html(
    //         //         Utils.addCommasToNumber(endVal)
    //         //       )

    //         //       i++
    //         //     },
    //         //     incrementInterval
    //         //   )
    //         // });
    //       }
    //     }
    //   }
    // );
  }

  render() {
    return (
      <div className="MapStatsPanel row" ref="panel">
        <div className="col-xs-16">
          <h4 className="title">{Content[this.props.page].title}</h4>
        </div>
        <div className="col-xs-16 col-sm-8" data-scroll-item-once>
          <h5 className="stat top">{Content[this.props.page].stat1_top}</h5>
          <p className="stat" id="interviewsNumber"></p>
          <h5 className="stat bottom">{Content[this.props.page].stat1_bottom}</h5>
        </div>
        <div className="col-xs-16 col-sm-8" data-scroll-item-once>
          <h5 className="stat top">{Content[this.props.page].stat2_top}</h5>
          <p className="stat" id="conversationsNumber"></p>
          <h5 className="stat bottom">{Content[this.props.page].stat2_bottom}</h5>
        </div>
        <div className="hidden-sm-down col-sm-16 flags" data-scroll-item-once>
          <ul>
            {
              Content[this.props.page].flags.map((flag, index) => (
                <li key={index}>
                  {console.log(`../../assets/img/flags/${flag.asset}.png`)}
                  <img src={`../../assets/img/flags/${flag.asset}.png`} alt={flag.name}/>
                  <span>{flag.name}</span>
                </li>
              ))
            }
          </ul>
        </div>
        <div className="map-container">
          <div className="background-map">
            <WorldMapIcon viewBox="0 0 767.2 353.6"></WorldMapIcon>
          </div>
        </div>
      </div>
    );
  }

  totalConversationsThisYear() {
    const today = new Date()
    const daysThisYear = 30 * (today.getMonth() + 1) // NOTE not 100% accurate

    return parseInt((this.conversationsPerDay * daysThisYear), 10)
  }

  totalInterviews() {
    const start = new Date(2006,1,1)
    const end = new Date()
    const days = Utils.getNumberOfDaysBetweenDates(start, end)

    return parseInt((this.interviewsPerDay * days), 10)
  }



};
